<template>
  <div class='foot'>
    <img src="@/assets/images/index/footBg.jpg" class="bg">
    <img src="@/assets/images/index/footLogoLeft.png" class="logoLeft">
    <img src="@/assets/images/index/footLogoRight.png" class="logoRight">
    <div class='article' @click="$router.push('/article?id=1')"></div>
    <div class='article1' @click="$router.push('/article?id=2')"></div>
    <div class='article2' @click="$router.push('/article?id=3')"></div>
    <div class='article3' @click="goPage('https://www.facebook.com/FairyTownCindeBella')"></div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  data () {
    return {}
  },
  mounted(){
  },
  methods:{
    goPage(href){
      window.location.href=href;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@fullWidth:19.2rem;

@footHeight:174/100rem;
.foot{
  position: relative;
  width: @fullWidth;
  height: @footHeight;
  float:left;
  .article{
    position: absolute;
    width: .6rem;
    height:.3rem;
    left:11.4rem;
    top:1.1rem;
    cursor:pointer;
    // background:red;
  }
  .article1{
    position: absolute;
    width: .85rem;
    height:.3rem;
    left:12.2rem;
    top:1.1rem;
    cursor:pointer;
    // background:blue;
  }
  .article2{
    position: absolute;
    width: .85rem;
    height:.3rem;
    left:13.17rem;
    top:1.1rem;
    cursor:pointer;
    // background:yellow;
  }
  .article3{
    position: absolute;
    width: .85rem;
    height:.3rem;
    left:14.2rem;
    top:1.1rem;
    cursor:pointer;
    // background:green;
  }
  .bg{
    position: absolute;
    width: @fullWidth;
    left: 0;
    top: 0;
  }
  .logoLeft{
    position: absolute;
    width: 3.38rem;
    left: 3.2rem;
    top: .17rem;
  }
  .logoRight{
    position: absolute;
    width: 5.4rem;
    right: 3.2rem;
    top: .17rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/foot.vue